export const signatureMethodMixin = {
    data() {
        return {
            signatureMethods: {
                'sign_long' : '電子署名',
                'sign_light_timestamp' : '電子サイン＋タイムスタンプ',
                'sign_light' : '電子サイン'
            },
            signatureMethodsAbbreviation: {
                'sign_long' : '電子署名',
                'sign_light_timestamp' : '電子サイン＋TS',
                'sign_light' : '電子サイン'
            },
        }
    },
    methods: {
        getSignatureMethodText(signatureMethod) {
            if(!signatureMethod){
                return "";
            }
            return this.signatureMethods[signatureMethod];
        },
        getSignatureMethodTextAbbreviation(signatureMethod) {
            if(!signatureMethod){
                return "";
            }
            return this.signatureMethodsAbbreviation[signatureMethod];
        },
    }
}  
